module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/symbol-observable/index.js
// module id = ../../../../symbol-observable/index.js
// module chunks = 3